// Vassar College's undergraduate majors (#2748). Read on 2026-10-01 from the
// official Majors list on vassar.edu (Academics, Majors and Minors): every
// entry under "Majors" is kept, in the order and spelling Vassar uses
// ("Art, Studio", "Independent Program"); the "Correlate Sequences
// (Equivalent to a Minor)" list on the same page is left out. The 2026-2027
// Vassar College Catalogue (catalogue.vassar.edu) sits behind a robot check
// that blocks automated reading, so the Academics page is the source. The
// page gives no degree abbreviations, so `degree` is null; the Registrar's
// Academic Information page names the degree the Bachelor of Arts. The KB's
// majors list was not needed; Vassar's own list is the only source.
const majors = {
    "slug": "vassar-college",
    "read": "2026-10-01",
    "intro": "Every major on Vassar's official list of majors, as the Academics pages give it. Vassar is a single college, so the majors are one group; correlate sequences (Vassar's minors) and graduate programs are left out. The list does not name degree types.",
    "groups": [
        {
            "name": "Vassar College",
            "source": {
                "label": "Vassar College Academics, Majors",
                "url": "https://www.vassar.edu/academics/majors"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": null
                },
                {
                    "name": "American and Native American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Art, Studio",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Astronomy",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "Cognitive Science",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Drama",
                    "degree": null
                },
                {
                    "name": "Earth Science",
                    "degree": null
                },
                {
                    "name": "Earth Science and Society",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Film",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Geography-Anthropology",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "Global Nineteenth-Century Studies",
                    "degree": null
                },
                {
                    "name": "Greek and Roman Studies",
                    "degree": null
                },
                {
                    "name": "Hispanic Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Independent Program",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Japanese",
                    "degree": null
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Latin American and Latinx Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Media Studies",
                    "degree": null
                },
                {
                    "name": "Medieval and Renaissance Studies",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience and Behavior",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychological Science",
                    "degree": null
                },
                {
                    "name": "Religion",
                    "degree": null
                },
                {
                    "name": "Russian Studies",
                    "degree": null
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Urban Studies",
                    "degree": null
                },
                {
                    "name": "Women, Feminist, and Queer Studies",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
